import React, { useState, useEffect } from 'react';
import { message, Modal, Input, Button, Cascader } from 'antd'; // dialog UI}
import styles from './index.module.scss';
import client from '../../../../lib/feathers';

const ChooseType = ({
  chooseTypeDialog,
  setChooseTypeDialog,
  setChooseObject,
  setPublicAppointmentDialog,
  publicAppointForm,
  publicObject,
}) => {
  const [barcodeDialog, setBarcodeDialog] = useState(false);
  const [barcodeDisplay, setBarcodeDisplay] = useState('');
  const [rfIdDialog, setRfIdDialog] = useState(false);
  const [rfIdDisplay, setRfIdDisplay] = useState('');
  const [receiveHourDialog, setReceiveHourDialog] = useState(false);
  const [dataSourceSelect, setDataSourceSelect] = useState('');
  const [cascadeArr, setCascadeArr] = useState({});

  useEffect(() => {
    (async () => {
      const result = await client
        .service('residentAccountNumbers')
        .find({ query: {} });
      const newData = result.data.map((data) => {
        const newHouseholdNumber = data.householdNumber.split('-');
        return { ...data, householdNumber: newHouseholdNumber };
      });
      const objectData = [];
      newData.forEach((data) => {
        const number = data.householdNumber;
        if (!objectData.find((item) => item.value === number[0])) {
          objectData.push({ value: number[0], label: number[0], children: [] });
        }
      });
      // layer2
      newData.forEach((data) => {
        const number = data.householdNumber;
        if (number[1] !== undefined) {
          if (
            !objectData
              .find((item) => item.value === number[0])
              .children.find((item) => item.value === number[1])
          ) {
            objectData
              .find((item) => item.value === number[0])
              .children.push({
                value: number[1],
                label: number[1],
                children: [],
              });
          }
        }
      });
      // layer3
      newData.forEach((data) => {
        const number = data.householdNumber;
        if (number[2] !== undefined && number[1] !== undefined) {
          if (
            !objectData
              .find((item) => item.value === number[0])
              .children.find((item) => item.value === number[1])
              .children.find((item) => item.value === number[2])
          ) {
            objectData
              .find((item) => item.value === number[0])
              .children.find((item) => item.value === number[1])
              .children.push({ value: number[2], label: number[2] });
          }
        }
      });
      setCascadeArr(objectData);
    })();
  }, []);
  return (
    <>
      {/* 選擇掃描類別 */}
      <Modal
        title="請選擇掃描類別"
        width={1000}
        overflowScroll
        hasMask
        visible={chooseTypeDialog}
        footer={false}
        onCancel={() => {
          setChooseTypeDialog(false);
          setChooseObject(null);
        }}
        onClose={() => {
          setChooseTypeDialog(false);
          setChooseObject(null);
        }}
      >
        <div className={styles.imgContainer}>
          <div>
            <h2>掃描APP條碼</h2>
            <img
              className={styles.img}
              width={300}
              height={250}
              src="/ezcon/img/Barcode.svg"
              type="cover"
              style={{
                margin: '10px',
                backgroundColor: '#021E30',
              }}
              onClick={() => {
                setBarcodeDialog(true);
                setBarcodeDisplay(null);
              }}
              alt="scan"
            />
          </div>
          <div>
            <h2>掃描磁扣/卡片</h2>
            <img
              className={styles.img}
              width={300}
              height={250}
              src="/ezcon/img/Rfid.svg"
              type="cover"
              style={{
                margin: '10px',
                backgroundColor: '#021E30',
              }}
              onClick={() => {
                setRfIdDialog(true);
                setRfIdDisplay(null);
              }}
              alt="scan"
            />
          </div>
          <div>
            <h2>直接選擇戶號</h2>
            <img
              className={styles.img}
              width={300}
              height={250}
              src="/ezcon/img/Launcher icon_200.svg"
              type="cover"
              style={{
                margin: '10px',
                objectFit: 'cover',
              }}
              onClick={() => {
                setReceiveHourDialog(true);
                setDataSourceSelect(null);
              }}
              alt="select household number"
            />
          </div>
        </div>
      </Modal>
      {/* 掃描條碼 */}
      <Modal
        title="掃描條碼"
        mask={false}
        className={styles.barcodeDialog}
        visible={barcodeDialog}
        footer={false}
        onCancel={() => {
          setBarcodeDialog(false);
        }}
      >
        <div>
          <Input
            placeholder="自行輸入條碼 Enter確認"
            value={barcodeDisplay}
            onChange={(e) => {
              setBarcodeDisplay(e.target.value);
            }}
            onPressEnter={() => {
              const regex = /^[\d|a-zA-Z]+$/;
              if (!regex.test(barcodeDisplay)) {
                message.error('掃描失敗，僅能數字和英文');
                return;
              }
              try {
                client
                  .service('users')
                  .find({
                    query: {
                      barcodeType: barcodeDisplay,
                    },
                  })
                  .then((res) => {
                    console.log(
                      '==users householdNumber find barcodeType success:',
                      res.data[0].householdNumbers,
                      res.data[0].name
                    );
                    client
                      .service('residentAccountNumbers')
                      .find({
                        query: {
                          householdNumber: {
                            $in: res.data[0].householdNumbers,
                          },
                        },
                      })
                      .then((resData) => {
                        setChooseObject({
                          householdNumber: res.data[0].householdNumbers[0],
                          userName: res.data[0].name,
                          finalPoint:
                            resData.data[0].finalPoints +
                            resData.data[0].buyPoint,
                          type: 'barcode',
                          value: barcodeDisplay,
                        });
                        publicAppointForm.setFieldsValue({
                          ...publicObject,
                          householdNumber: res.data[0].householdNumbers[0],
                          userName: res.data[0].name,
                          userNameArr: [res.data[0].name],
                          publicAppointmentNumber: 1,
                          finalPoint:
                            resData.data[0].finalPoints +
                            resData.data[0].buyPoint,
                        });
                        setBarcodeDialog(false);
                        setPublicAppointmentDialog(true);
                        setChooseTypeDialog(false);
                        message.success('讀取成功');
                      });
                  });
              } catch (error) {
                console.log(error);
              }
            }}
          />
          <img
            className={styles.barcode}
            src="/ezcon/img/Barcode.svg"
            alt="barcode"
            type="cover"
            width={400}
            height={300}
            style={{
              margin: '10px',
              backgroundColor: '#021E30',
            }}
          />

          <h1>請掃描條碼...</h1>
        </div>
      </Modal>

      {/* 磁扣掃描 */}
      <Modal
        title="磁扣/卡片掃描"
        mask={false}
        className={styles.barcodeDialog}
        visible={rfIdDialog}
        footer={false}
        onCancel={() => {
          setRfIdDialog(false);
        }}
      >
        <div>
          <Input
            placeholder="自行輸入磁扣號碼 Enter確認"
            value={rfIdDisplay}
            onChange={(e) => {
              setRfIdDisplay(e.target.value);
            }}
            onPressEnter={() => {
              const regex = /^[\d|a-zA-Z]+$/;
              if (!regex.test(rfIdDisplay)) {
                message.error('掃描失敗，僅能數字和英文');
                return;
              }
              // 找到users戶號及姓名(注意要先新增users姓名 不然會沒有名字)=>用條碼或磁扣值找
              client
                .service('users')
                .find({
                  query: {
                    rfidType: rfIdDisplay,
                  },
                })
                .then((res) => {
                  console.log(
                    '==users householdNumber find barcodeType success:',
                    res.data[0].householdNumbers,
                    res.data[0].name
                  );
                  try {
                    client
                      .service('residentAccountNumbers')
                      .find({
                        query: {
                          householdNumber: {
                            $in: res.data[0].householdNumbers,
                          },
                        },
                      })
                      .then((resData) => {
                        console.log(
                          '==residentAccountNumbers find householdNumber success:',
                          res.data[0].finalPoints
                        );
                        setChooseObject({
                          householdNumber: res.data[0].householdNumbers[0],
                          userName: res.data[0].name,
                          finalPoint:
                            resData.data[0].finalPoints +
                            resData.data[0].buyPoint,
                          type: 'rfId',
                          value: rfIdDisplay,
                        });
                        publicAppointForm.setFieldsValue({
                          ...publicObject,
                          householdNumber: res.data[0].householdNumbers[0],
                          userName: res.data[0].name,
                          userNameArr: [res.data[0].name],
                          publicAppointmentNumber: 1,
                          finalPoint:
                            resData.data[0].finalPoints +
                            resData.data[0].buyPoint,
                        });
                        setRfIdDialog(false);
                        setPublicAppointmentDialog(true);
                        setChooseTypeDialog(false);
                        message.success('讀取成功');
                      });
                  } catch (error) {
                    console.error(error);
                  }
                });
            }}
          />

          <img
            className={styles.barcode}
            src="/ezcon/img/Rfid.svg"
            alt="rfid"
            type="cover"
            width={400}
            height={300}
            style={{ margin: '10px', backgroundColor: '#021E30' }}
          />

          <h1>請掃描磁扣/卡片...</h1>
        </div>
      </Modal>

      {/* 選擇戶號 */}
      <Modal
        mask={false}
        className={styles.barcodeDialog}
        visible={receiveHourDialog}
        footer={false}
        onCancel={() => {
          setReceiveHourDialog(false);
        }}
      >
        <div className={styles.householdNumberSelect}>
          <Cascader
            className={styles.buttonAdd}
            options={cascadeArr}
            expandTrigger="hover"
            placeholder="戶號查詢"
            value={dataSourceSelect}
            onChange={(value) => {
              console.log(value);
              setDataSourceSelect(value.join('-'));
            }}
          />
        </div>

        <img
          className={styles.barcode}
          src="/ezcon/img/Launcher icon_200.svg"
          alt="receive"
          // width={400}
          // height={300}
        />

        <div className={styles.householdNumberBox}>
          <h1>{dataSourceSelect || '請選擇戶號...'}</h1>
          <Button
            className={styles.householdNumberSend}
            type="secondary"
            onClick={() => {
              // 找到users戶號及姓名(注意要先新增users姓名 不然會沒有名字)=>用條碼或磁扣值找
              client
                .service('users')
                .find({
                  query: {
                    householdNumbers: {
                      $in: [dataSourceSelect],
                    },
                    f_password: { $exists: false },
                    expireTime: { $exists: false },
                  },
                })
                .then((res) => {
                  const userArr = [];
                  for (let i = 0; i < res.data.length; i++) {
                    userArr.push(res.data[i].name);
                  }
                  client
                    .service('residentAccountNumbers')
                    .find({
                      query: {
                        householdNumber: {
                          $in: res.data[0].householdNumbers,
                        },
                      },
                    })
                    .then((resData) => {
                      console.log(
                        '==residentAccountNumbers find householdNumber success:',
                        res.data[0].finalPoints
                      );
                      setChooseObject({
                        householdNumber: res.data[0].householdNumbers[0],
                        userName: userArr,
                        finalPoint:
                          resData.data[0].finalPoints +
                          resData.data[0].buyPoint,
                        type: 'householdNumber',
                        value: dataSourceSelect,
                      });
                      publicAppointForm.setFieldsValue({
                        ...publicObject,
                        householdNumber: res.data[0].householdNumbers[0],
                        userName: userArr[0],
                        userNameArr: userArr,
                        publicAppointmentNumber: 1,
                        finalPoint:
                          resData.data[0].finalPoints +
                          resData.data[0].buyPoint,
                      });

                      setReceiveHourDialog(false);
                      setPublicAppointmentDialog(true);
                      setChooseTypeDialog(false);
                    })
                    .catch((error) => {
                      console.log(
                        '==residentAccountNumbers find householdNumber fail:',
                        error
                      );
                    });
                })
                .catch((error) => {
                  setReceiveHourDialog(true);
                  message.error('此戶號尚未開通');
                  console.log(
                    '==users householdNumber find barcodeTyp fail:',
                    error
                  );
                });
            }}
          >
            確定
          </Button>
        </div>
      </Modal>
    </>
  );
};
export default ChooseType;
